import React from 'react';
import PropTypes from 'prop-types';
import tracking from 'dibs-tracking';
import { FormattedMessage } from 'react-intl';
import { createFragmentContainer, graphql } from 'react-relay';

const trackClick = term =>
    tracking.trackEvent({
        label: term,
        category: 'search suggestion text',
        action: 'semantic override clicked',
    });

export const SbSharedForceSearchLinkComponent = ({ itemSearch }) => {
    const { semanticSearch = {} } = itemSearch;
    const { forceSearchUri, originalSearchTerm } = semanticSearch;
    return forceSearchUri ? (
        <a href={forceSearchUri} onClick={() => trackClick(originalSearchTerm)}>
            <FormattedMessage
                id="sb.sharedForceSearchLink.linkText"
                defaultMessage='Search "{originalSearchTerm}" in All Products'
                values={{ originalSearchTerm }}
            />
        </a>
    ) : null;
};
SbSharedForceSearchLinkComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedForceSearchLink = createFragmentContainer(SbSharedForceSearchLinkComponent, {
    itemSearch: graphql`
        fragment SbSharedForceSearchLink_itemSearch on ItemSearchQueryConnection {
            semanticSearch {
                originalSearchTerm
                forceSearchUri
            }
        }
    `,
});
